import API from 'src/api'
import { http } from '../boot/axios'

export default {
  URL: API.GRAPHQL_URL + 'catalogs/',
  fetchAll (payload) {
    return new Promise((resolve, reject) => {
      http.get(`${this.URL}`, { params: payload })
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  fetch (catalog_id) {
    return new Promise((resolve, reject) => {
      http.get(`${this.URL + catalog_id}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  create (catalog) {
    return new Promise((resolve, reject) => {
      http.post(`${this.URL}`, catalog)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  update (catalog) {
    return new Promise((resolve, reject) => {
      http.put(`${this.URL}${catalog.id}`, catalog)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  delete (role_id) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.URL}${role_id}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  getElements (payload) {
    const request = {
      limit: 1000,
      page: 1,
      ...payload
    }
    delete request.catalog_id
    return new Promise((resolve, reject) => {
      http.get(this.URL + payload.catalog_id + '/elements', { params: request })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  searchElements (catalog_id, payload) {
    const params = {
      limit: 5,
      search: '',
      ...payload
    }
    return new Promise((resolve, reject) => {
      http.get(this.URL + catalog_id + '/elements', { params })
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  uploadFromFile (catalog_id, elements_file) {
    const upload = new FormData()
    upload.append('file', elements_file)
    return Promise((resolve, reject) => {
      http.post(this.URL + catalog_id + '/elements/import', upload)
        .then(data => { resolve(data) })
        .catch(err => { reject(err) })
    })
  },
  saveElement (cat_el) {
    const payload = {
      ...cat_el
    }
    delete payload.catalog_id
    delete payload.id
    const element = {
      id: cat_el.id,
      catalog_id: cat_el.catalog_id,
      element: payload
    }
    return new Promise((resolve, reject) => {
      if (element.id) {
        http.put(this.URL + element.catalog_id + '/elements/' + element.id, element)
          .then(data => { resolve(data.catalog_element) })
          .catch(err => { reject(err) })
      } else {
        http.post(this.URL + element.catalog_id + '/elements/', element)
          .then(data => { resolve(data.catalog_element) })
          .catch(err => { reject(err) })
      }
    })
  },
  deleteElement (element) {
    return new Promise((resolve, reject) => {
      http.delete(this.URL + element.catalog_id + '/elements/' + element.id)
        .then(data => { resolve(data) })
        .catch(err => { reject(err) })
    })
  },
  fetchCalimaxElements (catalog_id, payload) {
    let params = {
      limit: 5,
      search: '',
      ...payload
    }
    return new Promise((resolve, reject) => {
      http.post(this.URL + catalog_id + '/getElements', params)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  fetchCalimaxElementId (element_id) {
    return new Promise((resolve, reject) => {
      http.post(this.URL + 'getElement/' + element_id)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  }
}
